import React, { useCallback, useState } from 'react';

import { ProjectData } from 'types/Gantt';
import { COLOURS } from 'utils/color';
import { parseExcel } from 'utils/excelParser';

import GanttChartView from './components/GanttChartView';
import UploadView from './components/UploadView';
import { GanttPageContainer } from './styles';

const GanttChartPage = () => {
  const [data, setData] = useState<ProjectData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleFile = useCallback((file: File) => {
    if (!file) return;
    setError(null);
    setLoading(true);

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        if (!e.target?.result) throw new Error('Failed to read file.');
        const result = parseExcel(e.target.result as ArrayBuffer);
        setData(result);
        setError(null);
      } catch (err: any) {
        setError(err.message || String(err));
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    reader.onerror = () => {
      setError('Failed to read the file. It may be corrupted.');
      setLoading(false);
    };
    reader.readAsArrayBuffer(file);
  }, []);

  const handleReset = () => {
    setData(null);
    setError(null);
  };

  return (
    <GanttPageContainer sx={{ flex: 1, display: 'flex' }}>
      {loading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(255,255,255,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 999,
          }}>
          <div style={{ fontSize: 14, color: COLOURS.headerBg, fontWeight: 600 }}>Processing MS Planner Data...</div>
        </div>
      )}
      {data ? <GanttChartView data={data} onReset={handleReset} /> : <UploadView onFile={handleFile} error={error} />}
    </GanttPageContainer>
  );
};

export default GanttChartPage;
